
import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import PrimeReact from 'primereact/api';

import 'primereact/resources/primereact.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import 'prismjs/themes/prism-coy.css';

import './App.scss';
import './styles/layout.scss';
import './styles/themes/primeflex.min.css';
import './styles/themes/theme.css';

import AppHeader from './components/header/app-header';
import AppFooter from './components/footer/app-footer';
import { AuthenticationProxyPage, FundoSolidariedadeProxyPage, CommunicationPage, DashboardPage, FinancePage, ProfilePage, QuotesPage, PublicInfoPage, SuspensionPage, AllowanceListPage, ProductsPage, RegistrationFormPage, CheckoutPage, PaymentsPage, MobileAuthenticationProxyPage, SitePage, ActionsPage, ExternalFramePage, MeetingNotesPage, PublicProductsPage, TrainingsPage, CongressesPage, TrainingRegistrationsPage, TrainingQuestionnairePage, PortalEmpregoProxyPage, CongressRegistrationsPage, PublicCongressesPage, QuestionarioProxyPage, ComissaoInstaladoraProxyPage, BallotCheckerPage } from './pages';
import MenuHeader from './components/header/menu-header';
import SupportPage from './pages/support/support';

function App() {
  PrimeReact.ripple = true;

  const location = useLocation();
  const hideChrome = localStorage.getItem('Hideinapp') === "1" || location.pathname === process.env.PUBLIC_URL + "/ballot-check";

  return (
    <div className="App">

        {
          hideChrome ?
          <></>
          :
          <>
            <AppHeader/>
            <MenuHeader/>
          </>
        }
        
        <div className="layout-main-container">
          <div className="layout-main">
              <Routes>
                <Route path={process.env.PUBLIC_URL + "/"} element={<SitePage />} />
                <Route path={process.env.PUBLIC_URL + "/dashboard"} exact element={<DashboardPage />} />
                <Route path={process.env.PUBLIC_URL + "/actions"} exact element={<ActionsPage />} />
                <Route path={process.env.PUBLIC_URL + "/authentication"} element={<AuthenticationProxyPage />} />
                <Route path={process.env.PUBLIC_URL + "/authentication-mobile"} element={<MobileAuthenticationProxyPage />} />
                <Route path={process.env.PUBLIC_URL + "/fundo-solidariedade"} element={<FundoSolidariedadeProxyPage />} />
                <Route path={process.env.PUBLIC_URL + "/portal-emprego"} element={<PortalEmpregoProxyPage />} />
                <Route path={process.env.PUBLIC_URL + "/comissao-instaladora"} element={<ComissaoInstaladoraProxyPage />} />
                <Route path={process.env.PUBLIC_URL + "/questionario"} element={<QuestionarioProxyPage />} />
                <Route path={process.env.PUBLIC_URL + "/profile"} exact element={<ProfilePage />} />
                <Route path={process.env.PUBLIC_URL + "/finance"} element={<FinancePage />} />
                <Route path={process.env.PUBLIC_URL + "/suspension"} element={<SuspensionPage />} />
                <Route path={process.env.PUBLIC_URL + "/communication"} element={<CommunicationPage />} />
                <Route path={process.env.PUBLIC_URL + "/quotes"} element={<QuotesPage />} />
                <Route path={process.env.PUBLIC_URL + "/support"} element={<SupportPage />} />
                <Route path={process.env.PUBLIC_URL + "/info"} element={<PublicInfoPage />} />
                <Route path={process.env.PUBLIC_URL + "/allowances"} element={<AllowanceListPage />} />
                <Route path={process.env.PUBLIC_URL + "/products"} element={<ProductsPage />} />
                <Route path={process.env.PUBLIC_URL + "/products-public"} element={<PublicProductsPage />} />
                <Route path={process.env.PUBLIC_URL + "/payments"} element={<PaymentsPage />} />
                <Route path={process.env.PUBLIC_URL + "/registration-form"} element={<RegistrationFormPage />} />
                <Route path={process.env.PUBLIC_URL + "/checkout"} element={<CheckoutPage />} />
                <Route path={process.env.PUBLIC_URL + "/document"} element={<ExternalFramePage />} />
                <Route path={process.env.PUBLIC_URL + "/meeting-notes"} element={<MeetingNotesPage />} />
                <Route path={process.env.PUBLIC_URL + "/trainings"} element={<TrainingsPage />} />
                <Route path={process.env.PUBLIC_URL + "/congressos"} element={<CongressesPage />} />
                <Route path={process.env.PUBLIC_URL + "/congressos-public"} element={<PublicCongressesPage />} />
                <Route path={process.env.PUBLIC_URL + "/training-registrations"} element={<TrainingRegistrationsPage />} />
                <Route path={process.env.PUBLIC_URL + "/congress-registrations"} element={<CongressRegistrationsPage />} />
                <Route path={process.env.PUBLIC_URL + "/training-survey"} element={<TrainingQuestionnairePage />} />
                <Route path={process.env.PUBLIC_URL + "/ballot-check"} element={<BallotCheckerPage />} />
              </Routes>
          </div>
        </div>  

        {
          hideChrome ?
          <></>
          :
          <>
            <AppFooter/>
          </>
        }
        
    </div>
  );
}

export default App;
